<template>
  <div>
    <NavPage></NavPage>
    <!-- Header section start -->
    <section id="home" class="home-wrapper section-b-space overflow-hidden">
      <!-- Accepted Order Info Banner -->
      <!-- <div v-if="acceptedOrder" class="accepted-order-banner pt-3">
        <div class="order-info-container">
          Shop Info - အမြဲပြမယ်
          <div class="shop-info">
            <h3 class="mb-1 ms-1" style="text-decoration: underline">Shop Info</h3>
            <div class="shop-name">
              <strong>📍 {{ acceptedOrder.shopName || "Shop" }}</strong>
            </div>
            <div class="shop-phone">
              <a :href="`tel:${acceptedOrder.shopPhone}`" class="phone-link">
                📞 {{ acceptedOrder.shopPhone || "N/A" }}
              </a>
            </div>
          </div>

          Customer Info - အမြဲပြမယ်
          <div class="customer-info">
            <h3 class="mb-1 ms-1" style="text-decoration: underline">Customer Info</h3>
            <div class="customer-name">
              <strong>👤 {{ acceptedOrder.customerName || "Customer" }}</strong>
            </div>
            <div class="customer-phone">
              <a :href="`tel:${acceptedOrder.customerPhone}`" class="phone-link">
                📞 {{ acceptedOrder.customerPhone || "N/A" }}
              </a>
            </div>
          </div>

          <div class="order-info">
            <div class="order-code">Order: {{ acceptedOrder.orderCode }}</div>
            <div class="order-total">Total: {{ acceptedOrder.subtotal }}</div>
          </div>
        </div>

        Order Detail Button
        <div class="order-detail-btn-container">
          <button @click="showOrderDetail" class="order-detail-btn">
            📋 Order Detail
          </button>
        </div>
      </div> -->
    </section>

    <!-- Order Detail Modal -->
    <div
      v-if="showDetailModal"
      class="order-detail-modal"
      @click.self="showDetailModal = false"
    >
      <div class="detail-modal-content">
        <div class="modal-header">
          <h3>Order Details</h3>
          <button @click="showDetailModal = false" class="close-modal-btn">×</button>
        </div>

        <!-- ✅ Location Buttons -->
        <div class="location-btn-section">
          <button
            class="location-btn"
            @click="openMap(orderDetail?.customer_lat, orderDetail?.customer_lng)"
          >
            📍 Customer Location
          </button>

          <button
            class="location-btn shop"
            @click="openMap(orderDetail?.shop_lat, orderDetail?.shop_lng)"
          >
            🏪 Shop Location
          </button>
        </div>

        <div v-if="isLoadingDetail" class="loading-spinner">
          <i class="ri-loader-4-line ri-spin"></i> Loading...
        </div>

        <div v-else-if="orderDetail" class="detail-content">
          <!-- Order Items -->
          <div class="items-section">
            <h4>Order Items</h4>
            <div
              v-for="(group, groupIndex) in orderDetail.order_groups"
              :key="groupIndex"
            >
              <div
                v-for="(item, itemIndex) in group.order_items"
                :key="itemIndex"
                class="food-item"
              >
                <!-- Check if item has includes -->
                <template v-if="item.includes && item.includes.length > 0">
                  <!-- Check for select type in includes -->
                  <template v-if="hasSelectType(item.includes)">
                    <!-- CASE 2: Has select type includes - main food price မပါ -->
                    <div class="main-item">
                      <div class="food-name">{{ item.food.name }}</div>
                      <div class="food-price">—</div>
                      <div class="food-qty">× {{ item.quantity }}</div>
                      <div class="food-subtotal">—</div>
                    </div>

                    <!-- Include items -->
                    <div
                      v-for="(include, includeIndex) in item.includes"
                      :key="includeIndex"
                      class="include-items"
                    >
                      <div class="include-item">
                        <div class="include-name">{{ include.include_food.name }}</div>
                        <div class="include-price">
                          {{ formatPrice(include.include_food.price) }}
                        </div>
                        <div class="include-qty">× {{ include.quantity }}</div>
                        <div class="include-subtotal">
                          {{ formatPrice(include.include_food.price * include.quantity) }}
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- CASE 3: Has includes but no select type -->
                  <template v-else>
                    <div class="main-item">
                      <div class="food-name">{{ item.food.name }}</div>
                      <div class="food-price">{{ formatPrice(item.price) }}</div>
                      <div class="food-qty">× {{ item.quantity }}</div>
                      <div class="food-subtotal">
                        {{ formatPrice(item.price * item.quantity) }}
                      </div>
                    </div>

                    <!-- Include items -->
                    <div
                      v-for="(include, includeIndex) in item.includes"
                      :key="includeIndex"
                      class="include-items"
                    >
                      <div class="include-item">
                        <div class="include-name">{{ include.include_food.name }}</div>
                        <div class="include-price">
                          {{ formatPrice(include.include_food.price) }}
                        </div>
                        <div class="include-qty">× {{ include.quantity }}</div>
                        <div class="include-subtotal">
                          {{ formatPrice(include.include_food.price * include.quantity) }}
                        </div>
                      </div>
                    </div>
                  </template>
                </template>

                <!-- CASE 1: No includes - ရိုးရိုး item -->
                <template v-else>
                  <div class="main-item">
                    <div class="food-name">{{ item.food.name }}</div>
                    <div class="food-price">{{ formatPrice(item.price) }}</div>
                    <div class="food-qty">× {{ item.quantity }}</div>
                    <div class="food-subtotal">
                      {{ formatPrice(item.price * item.quantity) }}
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <!-- Summary -->
          <div class="summary-section">
            <div class="summary-row">
              <span>Subtotal:</span>
              <span>{{ formatPrice(calculateSubtotal) }}</span>
            </div>
            <div class="summary-row">
              <span>Delivery Fee:</span>
              <span>{{ formatPrice(orderDetail.delivery_fee - 7) }}</span>
            </div>
            <div class="summary-row">
              <span>Tax Fee:</span>
              <span> 7฿ </span>
            </div>
            <div class="summary-row total">
              <span>Total:</span>
              <span>{{ formatPrice(orderDetail.total_price) }}</span>
            </div>
          </div>
        </div>

        <div v-else class="error-message">Failed to load order details</div>
      </div>
    </div>
    <!-- Header Section end -->
  </div>
</template>

<script setup>
import { defineProps, ref, computed } from "vue";
import NavPage from "../navigation/NavPage.vue";
import axios from "@/api";
import { useToast } from "vue-toastification";

const props = defineProps({
  acceptedOrder: {
    type: Object,
    default: null,
  },
});

const toast = useToast();
const showDetailModal = ref(false);
const isLoadingDetail = ref(false);
const orderDetail = ref(null);

const hasSelectType = (includes) => {
  if (!includes || includes.length === 0) return false;
  return includes.some((inc) => inc.include_food?.check_type === "select");
};

const calculateSubtotal = computed(() => {
  if (!orderDetail.value) return 0;

  let subtotal = 0;

  orderDetail.value.order_groups?.forEach((group) => {
    group.order_items?.forEach((item) => {
      const hasSelect = hasSelectType(item.includes);

      if (hasSelect) {
        item.includes?.forEach((include) => {
          subtotal += parseFloat(include.include_food?.price || 0) * include.quantity;
        });
      } else {
        subtotal += parseFloat(item.price) * item.quantity;
        item.includes?.forEach((include) => {
          subtotal += parseFloat(include.include_food?.price || 0) * include.quantity;
        });
      }
    });
  });

  return subtotal;
});

const showOrderDetail = async () => {
  if (!props.acceptedOrder?.orderCode) {
    toast.error("Order ID not found");
    return;
  }

  const orderId = props.acceptedOrder.orderCode.replace("#", "");
  const token = localStorage.getItem("token");

  if (!token) {
    toast.error("Please login again");
    return;
  }

  showDetailModal.value = true;
  isLoadingDetail.value = true;

  try {
    console.log("Fetching order detail for:", orderId);

    // ✅ Use correct API endpoint
    const response = await axios.get(`/delivery-order-detail/${orderId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    console.log("API Response:", response.data);

    // ✅ Handle different response structures
    if (response.data.success && response.data.data) {
      orderDetail.value = response.data.data;
    } else {
      orderDetail.value = response.data;
    }

    console.log("Order detail loaded:", orderDetail.value);

  } catch (error) {
    console.error("Error loading order details:", error);

    if (error.response) {
      if (error.response.status === 401) {
        toast.error("Unauthorized. Please login again.");
      } else if (error.response.status === 404) {
        toast.error("Order not found or not assigned to you");
      } else {
        toast.error(error.response.data?.message || "Failed to load order details");
      }
    } else if (error.request) {
      toast.error("No response from server");
    } else {
      toast.error(error.message);
    }
  } finally {
    isLoadingDetail.value = false;
  }
};

const openMap = (lat, lng) => {
  if (!lat || !lng) {
    toast.error("Location not available");
    return;
  }

  const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
  window.open(url, "_blank");
};

const formatPrice = (price) => {
  return Number(price || 0).toFixed(2) + " ฿";
};
</script>

<style scoped>
/* Accepted Order Banner Styles */
.accepted-order-banner {
  background: linear-gradient(135deg, #ff6b00, #ff8c00);
  color: white;
  padding: 12px 15px;
  margin: 10px 15px;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(255, 107, 0, 0.3);
  animation: slideDown 0.5s ease-out;
}

.order-info-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
}

.shop-info,
.customer-info {
  flex: 1;
  min-width: 150px;
}

.shop-name,
.customer-name {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
}

.shop-phone,
.customer-phone {
  font-size: 14px;
}

.phone-link {
  color: white;
  text-decoration: none;
  transition: opacity 0.3s ease;
}

.phone-link:hover {
  opacity: 0.8;
  text-decoration: underline;
}

.order-info {
  display: flex;
  flex-direction: column;
  gap: 5px;
  background: rgba(255, 255, 255, 0.2);
  padding: 6px 12px;
  border-radius: 20px;
  backdrop-filter: blur(10px);
}

.order-code,
.order-total {
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

/* Animation */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .order-info-container {
    gap: 6px;
    margin-left: 1;
  }

  .shop-info,
  .customer-info {
    min-width: 130px;
  }
}

@media (max-width: 580px) {
  .order-info-container {
    flex-direction: row;
    align-items: center;
  }

  .shop-info,
  .customer-info {
    width: 100%;
    min-width: auto;
  }

  .order-info {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 5px;
  }
}

@media (max-width: 480px) {
  .accepted-order-banner {
    margin: 8px 10px;
    padding: 10px 12px;
  }

  .shop-name,
  .customer-name {
    font-size: 15px;
  }

  .shop-phone,
  .customer-phone {
    font-size: 13px;
  }

  .order-code,
  .order-total {
    font-size: 11px;
  }
}

@media (max-width: 360px) {
  .accepted-order-banner {
    margin: 5px 8px;
    padding: 8px 10px;
  }

  .shop-name,
  .customer-name {
    font-size: 14px;
  }

  .shop-phone,
  .customer-phone {
    font-size: 12px;
  }

  .order-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;
  }
}

.order-detail-btn-container {
  margin-top: 12px;
  text-align: center;
}

.order-detail-btn {
  background: rgba(255, 255, 255, 0.25);
  border: 2px solid white;
  color: white;
  padding: 10px 20px;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 300px;
  backdrop-filter: blur(5px);
}

.order-detail-btn:hover {
  background: rgba(255, 255, 255, 0.4);
  transform: translateY(-2px);
}

/* Order Detail Modal */
.order-detail-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 15px;
}

.detail-modal-content {
  background: white;
  border-radius: 16px;
  max-width: 500px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
  animation: modal-appear 0.3s ease-out;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  position: sticky;
  top: 0;
  background: white;
  border-radius: 16px 16px 0 0;
}

.modal-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
}

.close-modal-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  padding: 0 8px;
}

.close-modal-btn:hover {
  color: #333;
}

.loading-spinner {
  text-align: center;
  padding: 40px;
  color: #666;
}

.detail-content {
  padding: 20px;
}

.items-section {
  margin-bottom: 20px;
}

.items-section h4 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
  border-bottom: 2px solid #ff6b00;
  padding-bottom: 8px;
}

.food-item {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 8px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 10px;
}

.main-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.food-name {
  flex: 2;
  font-weight: 600;
  color: #333;
}

.food-price,
.include-price {
  flex: 1;
  text-align: right;
  color: #666;
}

.food-qty,
.include-qty {
  flex: 0.5;
  text-align: center;
  color: #666;
}

.food-subtotal,
.include-subtotal {
  flex: 1;
  text-align: right;
  font-weight: 600;
  color: #ff6b00;
}

.include-items {
  width: 100%;
  margin-left: 20px;
  margin-top: 5px;
}

.include-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 8px;
  background: #ffffff;
  border-radius: 6px;
  margin-bottom: 4px;
  border-left: 3px solid #ff6b00;
}

.include-name {
  flex: 2;
  font-weight: 500;
  color: #555;
}

.include-badge {
  font-size: 0.7rem;
  background: #ff6b00;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  text-transform: uppercase;
  margin-left: 5px;
}

.summary-section {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 12px;
  margin-top: 20px;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  color: #666;
}

.summary-row.total {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 2px solid #ddd;
  font-weight: 700;
  color: #333;
  font-size: 16px;
}

.error-message {
  text-align: center;
  padding: 40px;
  color: #e74c3c;
}

@keyframes modal-appear {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* Responsive */
@media (max-width: 480px) {
  .order-detail-btn {
    max-width: 100%;
    font-size: 13px;
    padding: 8px 16px;
  }

  .food-item {
    gap: 5px;
  }

  .food-name {
    flex: 100%;
    margin-bottom: 5px;
  }

  .food-price,
  .food-qty,
  .food-subtotal {
    flex: 1;
    text-align: left;
  }
}

.location-btn-section {
  margin-top: 15px;
  display: flex;
  gap: 10px;
}

.location-btn {
  flex: 1;
  padding: 10px;
  border-radius: 10px;
  border: none;
  background: #ff6b00;
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
}

.location-btn.shop {
  background: #2c3e50;
}

.location-btn:hover {
  opacity: 0.9;
  transform: translateY(-2px);
}
</style>
